/**
 * Shared wording for Member Application Links.
 *
 * Plain spoken register. No dashes, no ministry vocabulary, no promises about
 * outcomes. These strings are display copy, not machinery.
 */

export const INVITE_TEACHING =
  'This link is the paper application, handed to one person. Share it personally with the person who asked about membership. It is never posted publicly, never put on a website, and never sent to a list. Membership is by invitation and discretion, and the link expires in two weeks.';

export const DECLINE_NOTE =
  'Declining records the decision and nothing else. No notice is written and no reason is given. The Association owes nothing and explains nothing.';

export const MINOR_NOTE =
  "A minor's path runs through a parent or guardian with its own consent. Talk with the team before deciding.";

export const ATTESTATION_SCREEN_LINE =
  'This one signs in blue ink at the sitting where the new member reads the Doctrine and the Covenant. Print it, sign it, scan it to the Record.';

export const SUBMITTED_MESSAGE =
  'Your application is with the Officers. Membership decisions are private, and you will hear from them directly if there is more to say.';

export const INVALID_TOKEN_MESSAGE =
  'This link is not active. Reach out to the person who shared it with you.';

export interface AffirmationItem {
  key: string;
  text: string;
}

export const AFFIRMATIONS: AffirmationItem[] = [
  {
    key: 'stewardship_conviction',
    text: 'I understand the Association is a private religious association whose members hold that what they have is stewarded rather than owned, and I desire to live in private association with its members under that conviction.',
  },
  {
    key: 'invitation_and_discretion',
    text: 'I understand that Membership is by invitation and discretion, that this application creates no entitlement to admission, response, or explanation, and that all matters concerning it are private.',
  },
];

/** Whole years between a date of birth and a reference date. */
export function ageFromDateOfBirth(dob?: string | null, on?: Date): number | null {
  if (!dob) return null;
  const born = new Date(dob);
  if (Number.isNaN(born.getTime())) return null;
  const ref = on || new Date();
  let age = ref.getFullYear() - born.getFullYear();
  const monthDiff = ref.getMonth() - born.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && ref.getDate() < born.getDate())) age -= 1;
  return age;
}

export function isMinor(dob?: string | null): boolean {
  const age = ageFromDateOfBirth(dob);
  return age !== null && age < 18;
}

/** Certificate numbers read like 2026-004. */
export function certificateNumber(year: number, sequence: number): string {
  return `${year}-${String(sequence).padStart(3, '0')}`;
}
